<template>
  <div class="top-contianer">
    <div class="main_header">
      <h1 style="width: 80%; margin: auto;color: #00264a;">All Needs in one place</h1>
      <h5
        class="tips"
      >Vortex offers fantastic opportunities for new/used components through its store, be ready to claim it.</h5>
      <br />
      <h5
        class="tips"
      >You can submit your order using the website, message on facebook or feel free to call us anytime.</h5>
      <b-row>
        <b-col>
          <div class="google button">
            <i class="icon">
              <i class="fa">&#xf095;</i>
            </i>
            <div class="slide">
              <p>Call Our Store</p>
            </div>
            <a
              style="position:relative; top: 20%;"
              href="tel:+201140775785"
            >+20&nbsp; 114&nbsp; 0775785</a>
          </div>
        </b-col>
      </b-row>
      <div class="grey_strip"></div>
    </div>
    <GearsSep />
    <div style="text-align: center; width: 100%;">
      <div style="display: inline-block; width: 84.22%;">
        <StoreItems v-for="i in items" :key="i.id" v-bind:item="i" />
      </div>
    </div>
  </div>
</template>

<script>
import GearsSep from "./../components/GearsSep.vue";
import StoreItems from "./../components/StoreItems.vue";
export default {
  name: "Store",
  components: {
    GearsSep,
    StoreItems
  },
  mounted() {
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "#00264a";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name.png");
  },
  data() {
    return {
      items: [
        {
          name: "Video Balun",
          id: "1",
          images: [
            { id: 0, src: "img/store/videobalun/1.jpg" },
            { id: 1, src: "img/store/videobalun/2.jpg" }
          ],
          link:
            "https://drive.google.com/drive/u/1/folders/1DFhXemX41cV5lAZvAvP2xLLUrj6gVdQo?fbclid=IwAR2m1svGUZ6ieVDCI9dlmdBaCAY6rXcC70HEjdCsaWCFHh5hb3XCXwT7KBs",
          price: { value: 35, type: "Item" },
          hidePrice: true,
          details:
            "A Video Balun enables the transmission of video signal using one unshielded twisted pair wire instead of coaxial cable. It is positioned on both ends of the CAT 5/5E/6 cable run and uses one of the twisted pairs from the cable to transfer the video from the camera to a DVR. You could use the four twisted pairs in the cable to transfer the video for up to 4 cameras. By using the video balun, an unshielded twisted pair wire can transmit video for much longer distances than coax cable and with a lower cable cost.Compatible with: AHD/CVI/TVITransmission distance: 300 m (for AHD/CVI) – 200 m (for TVI)Built-in surge and transient protection",
          description:
            "A Single Channel Passive HDCVI Transceiver, it transmits video signal using unshielded twisted pair instead of coaxial cable.",
          quantity: "3",
          features: ["No features available"],
          linkContains: ["Datasheet"],
          variations: [""],
          addOns: ["9", "10"]
        },
        {
          name: "3D Pro Joystick",
          id: "2",
          images: [
            { id: 0, src: "img/store/joystick/1.jpg" },
            { id: 1, src: "img/store/joystick/2.jpg" },
            { id: 2, src: "img/store/joystick/3.jpg" }
          ],
          link:
            "https://drive.google.com/drive/u/1/folders/1hNIo5cCb7SskHLmyO_gInDyHWDHv2oHw?fbclid=IwAR2m1svGUZ6ieVDCI9dlmdBaCAY6rXcC70HEjdCsaWCFHh5hb3XCXwT7KBs",
          price: { value: 1090, type: "Item" },
          hidePrice: true,
          details:
            "The Extreme Logitech 3D Pro is a video gaming joystick released by Logitech. The base has six programmable buttons that can be mapped for any use, as well as a throttle lever that sits on the front of the device. There is also five more programmable buttons on the top of the joystick, four of which are on the top face and one of them rests on the side as a thumb button. The top face also has a small hat switch that has multiple input directions. It also has a rapid-fire trigger which will capture every twitch of your finger. This joystick is powered by a USB connected directly to PC.",
          description:
            "The Extreme Logitech 3D Pro is a video gaming joystick released by Logitech.",
          quantity: "0",
          features: ["No features available"],
          linkContains: ["Product Specifications Catalog"],
          variations: [""],
          addOns: []
        },
        {
          name: "Acrylic Tube 7x3",
          id: "3",
          images: [
            { id: 0, src: "img/store/acrylic7x3/1.jpg" },
            { id: 1, src: "img/store/acrylic7x3/2.jpg" },
            { id: 2, src: "img/store/acrylic7x3/3.jpg" }
          ],
          link:
            "https://drive.google.com/drive/u/1/folders/1oQW6juVzXsU56oLTpIp3r6OBX54krG3y",
          price: { value: 11.75, type: "cm" },
          hidePrice: true,
          details:
            "Acrylic Tubes have various applications such as lighting, architecture and decorations. The tube is also commonly used as an enclosure for cameras; it provides clear vision - 360 degrees - and provides protection from external environmental factors.",
          description:
            "Acrylic Tube Dimensions: 7 cm outer diameter, 3 mm thickness, customized length (from 20 cm to 200 cm)",
          quantity: "3",
          features: ["No features available"],
          linkContains: ["CAD model (.SLDPRT)", "Drawing sheet ", "Datasheet "],
          variations: ["11 x 5 cm", "15 x 5 cm"],
          addOns: ["8"]
        },
        {
          name: "Acrylic Tube 11x5",
          id: "4",
          images: [
            { id: 0, src: "img/store/acrylic11x5/1.jpg" },
            { id: 1, src: "img/store/acrylic11x5/2.jpg" },
            { id: 2, src: "img/store/acrylic11x5/3.jpg" }
          ],
          link:
            "https://drive.google.com/drive/folders/10OITmUajVJfdP0lwS9mXmp2gsimis0BG?fbclid=IwAR2m1svGUZ6ieVDCI9dlmdBaCAY6rXcC70HEjdCsaWCFHh5hb3XCXwT7KBs",
          price: { value: 20, type: "cm" },
          hidePrice: true,
          details:
            "Acrylic Tubes have various applications such as lighting, architecture and decorations. The tube is also commonly used as an enclosure for cameras; it provides clear vision - 360 degrees - and provides protection from external environmental factors.",
          description:
            "11 cm outer diameter, 5 mm thickness, customized length (from 20 cm to 200 cm)",
          quantity: "3",
          features: ["No features available"],
          linkContains: ["CAD model (.SLDPRT)", "Drawing sheet ", "Datasheet "],
          variations: ["15 x 5 cm", "7 x 3 cm"],
          addOns: ["8"]
        },
        {
          name: "Acrylic Tube 15x5",
          id: "5",
          images: [
            { id: 0, src: "img/store/acrylic15x5/1.jpg" },
            { id: 1, src: "img/store/acrylic15x5/2.jpg" },
            { id: 2, src: "img/store/acrylic15x5/3.jpg" }
          ],
          link:
            "https://drive.google.com/drive/folders/1DwLmp4-jqR1RROzrwNvcHL3dw0cLdqbm?fbclid=IwAR3yspUPN3gD1wIwzsjGeOTAYqnJZjacL-qebqRBfgbhAD1MhVaf20O4vzI",
          price: { value: 25, type: "cm" },
          hidePrice: true,
          details:
            "Acrylic Tubes have various applications such as lighting, architecture and decorations. The tube is also commonly used as an enclosure for cameras; it provides clear vision - 360 degrees - and provides protection from external environmental factors.",
          description:
            "15 cm outer diameter, 5 mm thickness, customized length (from 20 cm to 200 cm)",
          quantity: "3",
          features: ["No features available"],
          linkContains: ["CAD model (.SLDPRT)", "Drawing sheet ", "Datasheet "],
          variations: ["11 x 5 cm", "7 x 3 cm"],
          addOns: ["8"]
        },
        {
          name: "Bilge Pump",
          id: "6",
          images: [
            { id: 0, src: "img/store/bilgepump/1.jpg" },
            { id: 1, src: "img/store/bilgepump/2.jpg" },
            { id: 2, src: "img/store/bilgepump/3.jpg" },
            { id: 3, src: "img/store/bilgepump/4.jpg" },
            { id: 4, src: "img/store/bilgepump/5.jpg" },
            { id: 5, src: "img/store/bilgepump/6.jpg" }
          ],
          link:
            "https://drive.google.com/drive/u/2/folders/1xZ9O6Vmy33H1fsCrkkwmUEnFioUXne26?fbclid=IwAR2m1svGUZ6ieVDCI9dlmdBaCAY6rXcC70HEjdCsaWCFHh5hb3XCXwT7KBs",
          price: { value: 575, type: "Item" },
          hidePrice: true,
          details:
            "SEAFLO bilge Pump 1100 GPH. It pumps offer water evacuation activated by a panel or float switch. The larger impeller design and more robust motor makes it very practical. The bilge pump is entirely submersible with a stainless steel shaft and quiet operation feature.",
          description:
            "SEAFLO bilge Pump 1100 GPH. It pumps offer water evacuation activated by a panel or float switch.",
          quantity: "3",
          features: [
            "Flowrate: 1100 GPH",
            "Voltage: 12 Vdc",
            "Max draw: 3.0 A",
            "Fuse Amps: 5.0 A"
          ],
          linkContains: [
            "CAD model (.SLDPRT)",
            "Drawing sheet",
            "Datasheet",
            "User Manual"
          ],
          variations: [""],
          addOns: [""]
        },
        {
          name: "3D Printing Service",
          id: "7",
          images: [
            { id: 0, src: "img/store/3dprinting/0.jpg" },
            { id: 1, src: "img/store/3dprinting/1.jpg" },
            { id: 2, src: "img/store/3dprinting/2.jpg" },
            { id: 3, src: "img/store/3dprinting/3.jpg" }
          ],
          link: "",
          price: { value: 1.5, type: "gm" },
          hidePrice: true,
          details:
            "Send us your STL files, and get your design printed in PLA  in no time!",
          description:
            "Send us your STL files, and get your design printed in PLA  in no time!",
          quantity: "3",
          features: ["No features available"],
          linkContains: ["No link available"],
          variations: [""],
          addOns: [""]
        },
        {
          name: "Acrylic Dome 16cm",
          id: "8",
          images: [
            { id: 0, src: "img/store/dome/1.jpg" },
            { id: 1, src: "img/store/dome/2.jpg" },
            { id: 2, src: "img/store/dome/3.jpg" }
          ],
          link:
            "https://drive.google.com/drive/folders/1EE-7OUMCBbgBv6xLs9gkr74BiTb-vbYT?fbclid=IwAR2yZoEPn6NTUHkEN7CG0GoG43Sy7QDB9T90FwBzwtBNr5Z92KiCzTxmerI",
          price: { value: 450, type: "Item" },
          hidePrice: true,
          details:
            "Acrylic Domes have various applications such as lighting, architecture and decorations. The dome is also commonly used as an enclosure for cameras; it provides clear vision - 180 degrees - and provides protection from external environmental factors.",
          description:
            "The dome is commonly used as enclosure for cameras, it provides protection from external environmental factors.",
          quantity: "0",
          features: ["No features available"],
          linkContains: [
            "CAD model (.SLDPRT)",
            "Drawing sheet ",
            "Datasheet ",
            "Vision test"
          ],
          variations: ["16 cm"],
          addOns: [""]
        },
        {
          name: "Hikvision CCTV Camera",
          id: "9",
          images: [
            { id: 0, src: "img/store/cctv/1.jpg" },
            { id: 1, src: "img/store/cctv/2.jpg" },
            { id: 2, src: "img/store/cctv/3.jpg" },
            { id: 3, src: "img/store/cctv/4.jpg" },
            { id: 4, src: "img/store/cctv/5.jpg" },
            { id: 5, src: "img/store/cctv/6.jpg" },
            { id: 6, src: "img/store/cctv/7.jpg" }
          ],
          link:
            "https://drive.google.com/drive/folders/1dHjpA9NBqfZipvhmXpsH-KkL1L-SWU-3?fbclid=IwAR0C0dDDJoEoJz4piv9mjgCbfSnwkCR6JzbgTbDUw2SLh0IUxi_mfzMwFOk",
          price: { value: 250, type: "Item" },
          hidePrice: true,
          details:
            "A closed-circuit television camera (CCTV camera) can produce images or recordings for surveillance and security purposes. It can also be used for vision systems of ROVs and robots in general.",
          description: "Analog HD, 1 Megapixel , 2.8 mm lens. 92 degrees angle",
          quantity: "3",
          features: [
            "2.8 mm Lens with 92 degrees angle of view",
            "1 Megapixel high-performance CMOS",
            "Analog HD output, up to 720P resolution",
            "True Day/Night",
            "DNR, Smart IR",
            "Up to 20m IR distance",
            "Power Supply: 12 VDC±15%",
            "Power Consumption:  Max. 4W",
            "Weight:  250 gm"
          ],
          linkContains: [
            "CAD model (.SLDPRT)",
            "Drawing sheet ",
            "Datasheet ",
            "User Manual"
          ],
          variations: [""],
          addOns: ["1", "10"]
        },
        {
          name: "Hikvision TruboHD DVR",
          id: "10",
          images: [{ id: 0, src: "img/store/dvr/1.jpg" }],
          link:
            "https://drive.google.com/drive/folders/17RQEVl6JyaqxlQjgt9o2tfD1svkDYQ_P",
          price: { value: 785, type: "Item" },
          hidePrice: true,
          details: "A 4 channel digital video recorder (DVR)",
          description:
            "A digital video recorder (DVR) is an electronic device that records a video captured by one or more cameras (as a CCTV camera). ",
          quantity: "3",
          features: [
            "DS-7100HGHI-F1 SERIES",
            "4 Channels",
            "Support H.264+/H.264 video compression",
            "Support HDTVI/AHD/CVI/CVBS/IP video input",
            "4-ch 960p IP camera input ",
            "Max. 1200 m for 720p HDTVI signal",
            "Dual stream support (Video or Video with audio)",
            "Video bit rate: 32 Kbps to 4 Mbps",
            "Dimensions (W × D × H): 200 × 200 × 45 mm ",
            "Power supply: 12 VDC",
            "Consumption (without HDD) = 8 W",
            "Weight (without HDD) = 0.8 kg"
          ],
          linkContains: ["Datasheet"],
          variations: ["4 Channel"],
          addOns: ["1", "9"]
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.top-contianer {
  width: 100%;
}
.button {
  background: #dce0e0;
  position: relative;
  display: inline-block;
  height: 50px;
  margin: 4px;
  overflow: hidden;
  width: 200px;
  border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
}

.icon {
  display: block;
  float: left;
  position: relative;
  z-index: 3;
  height: 100%;
  vertical-align: top;
  width: 38px;
  -moz-border-radius-topleft: 3px;
  -moz-border-radius-topright: 0px;
  -moz-border-radius-bottomright: 0px;
  -moz-border-radius-bottomleft: 3px;
  -webkit-border-radius: 3px 0px 0px 3px;
  border-radius: 3px 0px 0px 3px;
  text-align: center;
}
.icon i {
  color: #fff;
  line-height: 42px;
}
.slide {
  z-index: 2;
  display: block;
  margin: 0;
  height: 100%;
  left: 38px;
  position: absolute;
  width: 163px;
  -moz-border-radius-topleft: 0px;
  -moz-border-radius-topright: 3px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 0px;
  -webkit-border-radius: 0px 3px 3px 0px;
  border-radius: 0px 3px 3px 0px;
}
.slide p {
  border-left: 1px solid #fff;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  color: #fff;
  font-size: 18px;
  left: 0;
  margin: 0;
  position: absolute;
  text-align: center;
  top: 10px;
  width: 100%;
}
.button .slide {
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

.google #___follow_0 {
  width: 70px !important;
  top: 10px;
  right: 45px;
  position: absolute;
  display: block;
  z-index: 1;
}
.google:hover .slide {
  bottom: -50px;
}

.google .icon,
.google .slide {
  background: #00264a;
}
</style>
